import { render, staticRenderFns } from "./ReachDigits.vue?vue&type=template&id=1804d25e&"
import script from "./ReachDigits.vue?vue&type=script&lang=js&"
export * from "./ReachDigits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports